import { gql } from "graphql-request";

export const GET_ALL_TRADEDATA_REAL = gql`
  query GetAllTradeData(
    $pageNo: Int
    $pageSize: Int
    $sortBy: String
    $sortType: Int
    $clientId: String
    $tenantId: String
    $searchKeyword: String 
    $filters: Json
    $dateFrom: String
    $dateTo: String
  ) {
    getAllTradeData(
      pageNo: $pageNo
      pageSize: $pageSize
      sortBy: $sortBy
      sortType: $sortType
      clientId: $clientId
      tenantId: $tenantId
      searchKeyword: $searchKeyword
      filters: $filters
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const GET_TRADE_DATA_COLUMNS = gql`
  query GetTradeDataColumns(
    $clientId: String
    $tenantId: String
  ) {
    getTradeDataColumns(
      clientId: $clientId
      tenantId: $tenantId
    ) {
      data
    }
  }
`;

export const CREATE_TRADE_DATA = gql`
  mutation CreateTradeData($tradeData: TradeDataInput!) {
    createTradeData(tradeData: $tradeData) {
      data
    }
  }
`;

export const DELETE_TRADE_DATA = gql`
  mutation DeleteAllTradeData($tenantId: String, $clientId: String) {
    deleteAllTradeData(tenantId: $tenantId, clientId: $clientId) {
      data
    }
  }
`;

export const GET_ALL_TRADEDATA_LOGS = gql`
  query GetTasksByTenant($input: GetTasksInput!) {
    getTasksByTenant(input: $input) {
      taskId
      status
      progress
      uploadTime
      fileName
      message
      lastHeartbeat
    }
  }
`;
